import { createContext, useContext, useMemo, useState } from "react";
import { translations } from "@/lib/i18n";

const LanguageContext = createContext({ lang: "it", setLang: () => {}, t: (k) => k });

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("it");
  const value = useMemo(() => {
    const dict = translations[lang] || translations.it;
    const t = (key) => dict[key] ?? key;
    return { lang, setLang, t };
  }, [lang]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => useContext(LanguageContext);
